import type { DeleteInvoiceResponse } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type useDeleteInvoicePayload = Parameters<WeftApi['deleteInvoice']>[0];

export function useDeleteInvoice(
  options?: UseMutationOptions<DeleteInvoiceResponse, unknown, useDeleteInvoicePayload['invoiceId']>,
) {
  const api = getPrivateApi();

  return useMutation((invoiceId) => api.deleteInvoice({ invoiceId }), options);
}
